import gql from 'graphql-tag';

export const getVisitorWatchlists = gql`
  query GetVisitorWatchlists($filter: VisitorWatchlistFilterInput) {
    visitorWatchlists(filter: $filter) {
      id
      organizationId
      visitorMatchingInfo {
        firstName {
          primaryValue
          alternateValues
          matchType
        }
        lastName {
          primaryValue
          alternateValues
          matchType
        }
        email {
          primaryValue
          alternateValues
          matchType
        }
        phone {
          primaryValue
          alternateValues
          matchType
        }
      }
      severityLevel
      notes
      attachmentIds
      reportedBy
      createdBy
      updatedBy
      createdAt
      updatedAt
      watchlistLevelConfig {
        id
        organizationId
        level
        displayLevelText
        isNotificationsEnabled
        notificationTargets
        isWatchlistDisplayed
        isApprovalRequired
      }
    }
  }
`;
